export default function debouncedHelper(callback, delay) {
  let timeout

  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => callback(...args), delay)
  };
}
